var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standard-layout',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('h1',[_vm._v("So erreichst Du uns")])]},proxy:true},{key:"main",fn:function(){return [_c('contact-form')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }